import type { AxiosInstance } from 'axios';

import { MissingApiClientError } from './errors';

let apiAxiosInstance: AxiosInstance | null = null;

export const registerApiAxiosInstance = ({ instance }: { instance: AxiosInstance }) => {
  apiAxiosInstance = instance;
};

export const getApiAxiosInstance = (): AxiosInstance => {
  if (!apiAxiosInstance) {
    throw new MissingApiClientError();
  }

  return apiAxiosInstance;
};
